import React from 'react'
import { useSelector } from 'react-redux'
import { useMoreInfoAction, useRewardLink } from 'cityads-v3/hooks/offers';
import { Offer } from 'cityads-v3/types/offers';
import { RootState } from 'cityads-v3/types/reducer';
import classNames from 'classnames'
import classes from './OfferCardActions.scss'

import Button from '@mui/material/Button';
import CardActions from '@mui/material/CardActions';
import GetLinkButton from 'cityads-v3/containers/webmaster/offerPage/GetLinkButton';
import IconButton from '@mui/material/IconButton';

import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import FavoriteOutlinedIcon from '@mui/icons-material/FavoriteOutlined';

type TOfferCardCustomActions = {
  title: string,
  isPrimary?: boolean,
  onClick(offer: Offer, evt: React.MouseEvent<HTMLButtonElement, MouseEvent>): void
}

type TOfferCardActionsProps = {
  offerId: number,
  customActions?: TOfferCardCustomActions[],
  offer: Offer,
  isCoupon?: boolean,
  onFavClick?(): void,
  className?: string,
  dense?: boolean,
}

type TButtonInfo = {
  title: string,
  isPrimary?: boolean,
}

export default function OfferCardActions({offerId, customActions, offer, isCoupon, onFavClick, className, dense} : TOfferCardActionsProps) : JSX.Element {
  const moreInfoButton = useMoreInfoAction(offerId) as TButtonInfo;
  const rewardButton = useRewardLink(offerId) as TButtonInfo;

  const isFavorite = useSelector((state: RootState) => Boolean(state.offers.offerFavoritesByOfferId[offerId]));
  const favoriteState = useSelector((state: RootState) => state.offers.offerFavoritesStateByOfferId[offerId]);

  const additionalButtons = [moreInfoButton, rewardButton].filter(button => !!button);

  return (
    <CardActions
      classes = {{root: classNames(classes.root, className)}}
    >
      <div className={classNames(classes.left, {
        [classes.left__dense]: dense
      })}>
        {customActions ? (
          customActions.map(({ isPrimary, title, onClick, ...button }, idx) => (
            <Button
              key={idx}
              color={isPrimary ? 'primary' : undefined}
              {...button}
              onClick={onClick ? (evt) => onClick(offer, evt) : undefined}
            >
              {title}
            </Button>
          ))
        ) : (
          <>
            <GetLinkButton
              id={offerId}
            />

            {additionalButtons.map(({ isPrimary, title, ...button }, idx) => (
              <Button
                key={idx}
                color={isPrimary ? 'primary' : 'info'}
                variant="contained"
                {...button}
              >
                {title}
              </Button>
            ))}

          </>
        )}
      </div>
      <div>
        {isCoupon ? null : (
          <IconButton
            size="large"
            classes={{root: classNames(classes.favButton, {
              [classes.favButton__dense]: dense
            })}}
            color={isFavorite ? 'primary' : undefined}
            disabled={favoriteState !== 'ready'}
            onClick={onFavClick}
          >
            {isFavorite ? <FavoriteOutlinedIcon /> : <FavoriteBorderOutlinedIcon />}
          </IconButton>
        )}
      </div>
    </CardActions>
  );
}
